import React, { useEffect } from 'react';
import './NotificationsPanel.css';

export default function NotificationsPanel({
  notifications,
  onClose,
  onMarkAllRead
}) {
  // Mark notifications as read when panel opens
  useEffect(() => {
    onMarkAllRead();
  }, [onMarkAllRead]);

  return (
    <div className="notifications-overlay" onClick={onClose}>
      <div
        className="notifications-panel"
        onClick={e => e.stopPropagation()}
      >
        <div className="notifications-header">
          <h3>Notifications</h3>
          <button onClick={onClose}>✕</button>
        </div>

        {notifications.length === 0 ? (
          <div className="notifications-empty">
            No notifications
          </div>
        ) : (
          <ul className="notifications-list">
            {notifications.map(n => (
              <li
                key={n.id}
                className={`notification-item ${n.read ? 'read' : 'unread'}`}
              >
                <div className="notification-title">
                  🚁 {n.droneName}
                </div>

                <div className="notification-message">
                  {n.message}
                </div>

                <div className="notification-time">
                  {new Date(n.timestamp).toLocaleTimeString()}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
